var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-wrapper',{attrs:{"title":"Space settings","section":"Quotas and usage"}},[_c('file-quotas',{attrs:{"space-id":_vm.activeSpaceId,"space-type":_vm.currentSpaceType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }